jQuery_T4NT(document).ready(function ($) {

  localStorage.setItem('T4Currency', $('.t4s-top-bar__currencies').find('span.flagst4').text())
          function getGeo(){
          var myHeaders = new Headers();
          myHeaders.append('pragma', 'no-cache');
          myHeaders.append('cache-control', 'no-cache');
          
          var myInit = {
            method: 'GET',
            headers: myHeaders,
          };
          localStorage.removeItem('user_region');
        fetch('http://ipwho.is/', myInit)
        .then(response => response.json())
        .then(data => {
          localStorage.setItem('user_region', data.region_code);
        })
        .catch(error => {
          console.error('Error fetching country information:', error);
        });
            }
  /**
  *  Variant selection changed
  *  data-variant-toggle="{{variant.id}}"
  */
  // 	   $( document ).on( "variant:changed", function( evt ) {
  // 	     // console.log( evt.currentVariant );
  // 	     // $('[data-variant-toggle]').hide(0);
  // 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
  // 	   });
  // // box_input_js
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}


  function totalPrice() {
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var box = parseFloat($('.box_input_js').val());
    var qty = Math.ceil(sqft_per_box * box); 
    if(qty < sqft_per_box){ qty = sqft_per_box; }
    $('.qty_input_js').val(qty);
    var price = parseFloat($('.qty_input_js').data('price'));
    var total = qty * price;
    $('.estimated-cost').html(T4SThemeSP.Currency?.formatMoney(total));
  }

  function calculate_Waste_Factor() {
    var perc = parseFloat($('.waste_input_js').val()) / 100;
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = parseFloat($('.sqft_input_js').val());
    var waste_factor = sqft * perc;
    if ($('.waste_input_js').is(':checked')) {
      sqft = sqft + waste_factor;
      $('#waste-factor-total span').html(waste_factor.toFixed(2));
    }

    var box = Math.ceil(sqft / sqft_per_box);
    if (box <= 0  || isNaN(box)) { box = 1 };
    $('.box_input_js').val(box);
    totalPrice();
  }

  $('body').on('input change', '.sqft_input_js', function (evt) {
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = parseFloat($(this).val());
    box = Math.ceil(sqft / sqft_per_box);
    if (box <= 0 || isNaN(box)) { box = 1 };
    $('.box_input_js').val(box);

    if (sqft < sqft_per_box  || isNaN(sqft)) {
      $('.min-qty-error').removeClass('hide');
    } else { $('.min-qty-error').addClass('hide'); }

    calculate_Waste_Factor();
  });

  $('body').on('input change', '.box_input_js', function (evt) {
    var box = parseInt($(this).val());
    var sqft_per_box = $('.sqft_input_js').attr('min');
    var sqft = sqft_per_box * box;
    $('.sqft_input_js').val(sqft);
    $('.min-qty-error').addClass('hide');
    calculate_Waste_Factor();
  });

  $('body').on('change', '.waste_input_js', function (evt) {
    if ($(this).is(':checked')) {
      $('#waste-factor-total').removeClass('hide');
    } else {
      $('#waste-factor-total').addClass('hide');
    }
    calculate_Waste_Factor();
  });

  $('body').on('click', '.cal_coverage_js', function(evt){
    $('#coverage-calculate').removeClass('hidden');

  });

  $('body').on('click', '.coverage-calculate-close', function(evt){
    $('#coverage-calculate').addClass('hidden');
  });


 $('body').on('click', '.add_row_js', function(evt){
   var html = `<div class="flex items-center justify-between mb-2 text-black uppercase text-xxs coverage-area-group">
              <div class="w-1/4 coverage-length">
              <input type="number" min="1" step=".01" placeholder="LENGTH" class="coverage_length w-full px-3 py-2 coverage-length-input bg-black/10"></div>
              <div class="text-xs coverage-symbol">✕</div>
              <div class="w-1/4 coverage-width">
              <input type="number" min="1" step=".01" placeholder="WIDTH" class="coverage_width w-full px-3 py-2 coverage-width-input bg-black/10"></div>
              <div class="text-xs coverage-symbol">=</div>
              <div class="w-1/3 coverage-area">
                <input type="number" disabled="disabled" class="coverage_area w-full px-3 py-2 coverage-area-output bg-black/20">
              </div>
            </div>`;


   $('.coverage-area-wrap').append(html);

   
 });

  function total_coverageArea(){
    var total = 0;
    $('.coverage-area-wrap .coverage_area').each(function(){
      var value = parseFloat($(this).val());
      if(value > 0){
        total = total + value;
      }
    });
   if(total > 0){
    $('.coverage-area-final').val(total);
   }
  }

  $('body').on('input change', '.coverage-area-wrap .coverage_width, .coverage-area-wrap .coverage_length', function(evt){
       var parent = $(this).parents('.coverage-area-group');
       var length = parseFloat(parent.find('input.coverage_length').val());
       var width = parseFloat(parent.find('input.coverage_width').val());
       var area  = length * width;
           area  = area.toFixed(2);
      
        parent.find('input.coverage_area').val(area);
        total_coverageArea();
  });



  $('body').on('click', '.use-coverage_js', function(evt){
        var coverage_area = parseFloat($('.coverage-area-final').val()).toFixed(2);
      if(coverage_area > 0){
             
         $('.sqft_input_js').val(coverage_area);
         $('.sqft_input_js').trigger('input');
        $('#coverage-calculate').addClass('hidden');
      }

   });
  //document.querySelectorAll('.js-product-samples').forEach(item => item.classList.remove[0]);
   async function loading(){
     
    // await console.log('Echeck Element =>>>>>',$(document)[0].readyState)
    while ($(document)[0].readyState !== 'complete') {
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
  // console.log('Echeck Element =>>>>>',$('div.product-samples-button-wrap'))
    return true;
}

    try { totalPrice(); } catch(e) {}

  

 });    
